module.exports = __webpack_public_path__ + "img/icon_02@2x.da89c23c.png";